import { render, staticRenderFns } from "./school_view.vue?vue&type=template&id=7075c6a6&scoped=true&"
import script from "./school_view.vue?vue&type=script&lang=js&"
export * from "./school_view.vue?vue&type=script&lang=js&"
import style0 from "./school_view.vue?vue&type=style&index=0&id=7075c6a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7075c6a6",
  null
  
)

export default component.exports